import React from 'react';
import militaireImage from '../../images/ceramiques.JPG';
import CategoryPage from '../CategoryPage';

function CeramiquesPage() {
    const details = [
        'Céramiques rares et précieuses',
        'Objets artisanaux en pâte de verre et porcelaine',
        'Pièces d’une grande valeur historique et esthétique',
        'Collections issues des traditions anciennes',
    ];

    return (
        <CategoryPage
            title="Céramiques"
            image={militaireImage}
            description="Découvrez des céramiques rares, des objets en pâte de verre et des pièces d’une grande valeur historique et esthétique, témoignant des traditions anciennes."
            details={details}
        />
    );
}

export default CeramiquesPage;
